import { Component, ViewEncapsulation, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-room-status-badge',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './room-status-badge.component.html',
})
export class RoomStatusBadgeComponent {
  readonly isCheckedIn = input.required<boolean>();
}
